export { default } from '@material-ui/icons/Delete';
